'use client';

import React from 'react';
import classNames from 'classnames';

const Nav = (props: {
  children: React.ReactNode;
  isBackgroundWhite: boolean;
  isStatic: boolean;
}) => {
  const { children, isBackgroundWhite, isStatic } = props;

  return (
    <nav
      className={classNames(
        'z-99 flex w-full flex-col items-center justify-center py-4 sm:py-5 md:py-6',
        {
          absolute: isStatic,
          'bg-transparent': !isBackgroundWhite,
          'bg-white': isBackgroundWhite,
          fixed: !isStatic,
        }
      )}
      id="navbar"
      aria-label="Primary"
    >
      {children}
    </nav>
  );
};

export default Nav;
